import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AddersService from "./AddersService";

const initialState = {
    adders: [],
    adder: [],
    services: [],
    isSuccess: false,
    isLoading: false,
    isError: false,
    errors: [],
    message: null,
};

export const GetAllAdders = createAsyncThunk(
    "adder/index",
    async (data, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersService.GetAllAdders(data, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);

export const GetSingleAdderMethod = createAsyncThunk(
    "adder/show",
    async (id, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersService.GetSingleAdder(id, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);

export const CreateAdderMethod = createAsyncThunk(
    "adder/show",
    async (data, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersService.CreateAdder(data, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);

export const UpdateAdderMethod = createAsyncThunk(
    "adder/update",
    async (data, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersService.UpdateAdder(data, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);

export const UpdateAdderStatus = createAsyncThunk(
    "adder/update",
    async (data, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersService.UpdateAdderStatus(data, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);
export const DeleteAddreMethod = createAsyncThunk(
    "adder/delete",
    async (id, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersService.DeleteAdder(id, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);

export const GetAllServiceTypes = createAsyncThunk(
    "services/get", async (_, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth?.mainUser.data.token;
            return await AddersService.GetAllServiceTypes(token)
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message)
        }
    } 
)

const AddersSlice = createSlice({
    name: "adders",
    initialState,
    reducers: {
        adderReset: (state) => {
            state.isSuccess = false;
            state.isLoading = false;
            state.isError = false;
            state.errors = [];
            state.message = null;
        },
    },
    extraReducers: {
        // Get All Adders
        [GetAllAdders.pending]: (state) => {
            state.isLoading = true;
        },
        [GetAllAdders.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            state.adders = action.payload;
        },
        [GetAllAdders.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },

        // Get Single Adders
        [GetSingleAdderMethod.pending]: (state) => {
            state.isLoading = true;
        },
        [GetSingleAdderMethod.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            state.adder = action.payload;
        },
        [GetSingleAdderMethod.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },

        // Create Adders
        [CreateAdderMethod.pending]: (state) => {
            state.isLoading = true;
        },
        [CreateAdderMethod.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            state.adder = action.payload;
        },
        [CreateAdderMethod.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },

        // Update Adders
        [UpdateAdderMethod.pending]: (state) => {
            state.isLoading = true;
        },
        [UpdateAdderMethod.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.adder = action.payload;
        },
        [UpdateAdderMethod.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.payload;
        },

        // Update Adders Status
        [UpdateAdderStatus.pending]: (state) => {
            state.isLoading = true;
        },
        [UpdateAdderStatus.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            state.adder = action.payload;
        },
        [UpdateAdderStatus.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },
        // Delete Adders
        [DeleteAddreMethod.pending]: (state) => {
            state.isLoading = true;
        },
        [DeleteAddreMethod.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            state.adder = action.payload;
        },
        [DeleteAddreMethod.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },
        // Get Servuces Types
        [GetAllServiceTypes.pending]: (state) => {
            state.isLoading = true;
        },
        [GetAllServiceTypes.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            console.log(action)
            state.services = action.payload;
        },
        [GetAllServiceTypes.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },    },
});

export const { adderReset } = AddersSlice.actions;
export default AddersSlice.reducer;
